import React from "react";
import { BooleanInput, Edit, SimpleForm, TextInput } from "react-admin";

const SemesterEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <BooleanInput source="current" />
    </SimpleForm>
  </Edit>
);

export default SemesterEdit;
